// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3FDKw","file":"styles_file__bSM32"};